import { z } from 'zod'

export const providerProfileStepDataSchema = z.object({
  bio: z
    .string()
    .min(1, 'Bio is required')
    .max(500, 'Bio must be at most 500 characters'),
  credentials_display: z
    .string()
    .min(1, 'Credentials display is required')
    .max(120, 'Credentials display must be at most 120 characters'),
  headshot_url: z.string().url('Headshot is required'),
})

export type ProviderProfileStepData = z.infer<typeof providerProfileStepDataSchema>
